import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";
import BrushRing from "./brushRing";

import disc from '../../../theme/assets/redesign/disc.svg';
import discSide from '../../../theme/assets/redesign/disc_side.svg';
import checkIcon from '../../../theme/assets/redesign/check.svg';
import lockIcon from '../../../theme/assets/redesign/lock.svg';
import joinArrow from '../../../theme/assets/redesign/join_arrow.svg';


// state: 'active' | 'completed' | 'upcoming'; featured — центральная (большая) карточка карусели
const RoundCard = ({state = 'active', featured = false, title, subtitle, percent = 0, raised, goal, onJoin, joinDisabled, onClick}) => {
    const {t} = useTranslation();
    const shownPercent = Math.round(Math.max(0, Math.min(100, percent)));

    return (
        <div
            className={`${Styles.card} ${featured ? Styles.featured : Styles.side} ${Styles[state]}`}
            onClick={onClick}
        >
            <img className={Styles.disc} src={featured ? disc : discSide} alt=""/>
            <BrushRing tone={state} percent={state === 'completed' ? 100 : percent}/>

            <div className={Styles.head}>
                <span>{title}</span>
                {subtitle ? <span>{subtitle}</span> : null}
            </div>
            <div className={Styles.percent}>{shownPercent}%</div>
            <div className={Styles.bar}>
                <div className={Styles.barFill} style={{width: `${state === 'completed' ? 100 : shownPercent}%`}}/>
            </div>
            <div className={Styles.amount}>
                <span className={Styles.raised}>{raised}</span>
                <span className={Styles.goal}>&nbsp;/ {goal}</span>
            </div>

            {featured && state === 'active' ? (
                <button
                    type="button"
                    className={`${Styles.action} ${joinDisabled ? Styles.actionDisabled : ''}`}
                    onClick={e => { e.stopPropagation(); onJoin && onJoin(); }}
                >
                    <span>{t('Участвовать')}</span>
                    <img src={joinArrow} alt="" width="18" height="18"/>
                </button>
            ) : null}
            {state === 'completed' ? (
                <div className={`${Styles.badge} ${Styles.badgeCompleted}`}>
                    <img src={checkIcon} alt="" width="16" height="16"/>
                    <span>{t('Завершён')}</span>
                </div>
            ) : null}
            {state === 'upcoming' ? (
                <div className={`${Styles.badge} ${Styles.badgeUpcoming}`}>
                    <img src={lockIcon} alt="" width="16" height="16"/>
                    <span>{t('Скоро')}</span>
                </div>
            ) : null}
        </div>
    );
};

export default RoundCard;
